<template>
  <div :class="{ 'with-new-btn': database.access_level !== 'read' }">
    <div class="kanban-board" v-if="!isLoading">
      <div class="kanban-board-header-wrap">
        <div class="kanban-board-header">
          <div v-for="stage in stageItems" :key="stage.name">
            <div
              class="stage-color"
              :style="{ 'background-color': getColor(stage.name) }"
            ></div>
            <div class="stage-count">{{ getStageCount(stage.name) }}</div>
            <h2>{{ stage.label }}</h2>
          </div>
        </div>
      </div>
      <kanban-board
        :stages="stageValues"
        :blocks="extendedBlocks"
        :statusProp="getStatusElementName"
        @update-block="updateBlock"
        ref="kanban"
      >
        <div v-for="stage in stageItems" :slot="stage.name" :key="stage.name">
          <div class="stage-count">{{ getStageCount(stage.name) }}</div>
          <h2>{{ stage.label }}</h2>
        </div>
        <div
          v-for="e in extendedBlocks"
          :slot="e.id"
          :key="e.id"
          :id="e.id"
          class="overlay-checkbox"
          @mouseenter="elOnHoverIdx = e.id"
          @mouseleave="hideActionDropdown()"
        >
          <div class="details">
            <div
              dz-preview-wrapper
              class="dz-preview-wrapper board-layout"
              :class="{ loadingWrapper: e.loading }"
            >
              <div class="dz-image">
                <!-- <div
                  class="data-dz-thumbnail-bg-overlay loading"
                  v-if="e.loading"
                >
                </div> -->
                <div
                  data-dz-thumbnail-bg-overlay
                  class="data-dz-thumbnail-bg-overlay"
                  :class="{ checked: e.selected }"
                >
                  <ul class="tools">
                    <li class="share" title="Teilen" @click="shareItem(e)">
                      <a>share</a>
                    </li>
                    <li
                      class="download"
                      title="Download"
                      @click="exportItem(e)"
                    >
                      <a>
                        <span class="accessibility">Download xls</span>
                      </a>
                    </li>
                    <li
                      v-if="
                        database.access_level !== 'read' && !database.add_only
                      "
                      data-dz-delete
                      class="delete"
                      title="Löschen"
                      @click="removeItem(e)"
                    >
                      <a>delete</a>
                    </li>
                    <li
                      class="dropdown"
                      title="Mehr"
                      @click="toggleActionDropdown()"
                      v-if="actionList()?.length || userHasPermissionToAddFlow"
                    >
                      <a>mehr</a>
                    </li>
                  </ul>
                  <div class="checker">
                    <span data-dz-checkbox>
                      <input type="checkbox" @click="check($event, e)" />
                    </span>
                  </div>
                  <a class="btn-oval" @click="goTo(e.id)"> Öffnen </a>
                </div>
              </div>
              <div class="progress-icon" v-if="e.loading"></div>
              <img
                v-if="false"
                class="user"
                v-bind:src="getImgUrl(e.assignee.pic)"
                alt
              />
              <div class="dz-details">
                <div
                  class="highlighted-item"
                  v-for="(value, key, index) in displayParam(e)"
                  :key="index"
                  :class="{ first: index === 0 }"
                >
                  <div v-if="isCorrectElementType(key, 'timestampms')">
                    {{ formatDate(value) }}
                  </div>
                  <div v-else>
                    {{ formatValues(value) }}
                  </div>
                </div>
                <div class="date" v-if="e.due">
                  <i class="far fa-clock"></i>
                  {{ e.due.date }}
                </div>
              </div>

              <!-- More components of dropzone preview
              <div class="dz-progress">
                <span class="dz-upload" data-dz-uploadprogress></span>
              </div>
              <div class="dz-details">
                <div
                  class="highlighted-item"
                  v-for="(value, key, index) in displayParam(e)"
                  :key="index"
                  :class="{ first: index === 0 }"
                >
                  {{ formatValues(value) }}
                </div>
                <div class="date" v-if="e.due">
                  <i class="far fa-clock"></i>
                  {{ e.due.date }}
                </div>
              </div>-->

              <!-- Dropdown menu for actions -->
              <div class="dropdown action-dropdown">
                <ul
                  v-if="isActionDropdownVisible && elOnHoverIdx === e.id"
                  class="item-hover"
                  @mouseleave="hideActionDropdown()"
                >
                  <li
                    class="listitem-hover"
                    v-for="a in actionList()"
                    :key="a.id"
                    @click="runAction(a.id)"
                  >
                    <div
                      class="loadingoverlay"
                      v-if="isDatabaseDropDownLoading(a.id, e[getSqlKey('id')])"
                    >
                      <div class="custom-table-progress-icon"></div>
                    </div>
                    {{ a.name }}
                  </li>
                  <li
                    v-if="userHasPermissionToAddFlow"
                    class="create-new-action"
                    @click="createNewAction(e.id)"
                  >
                    <i class="far fa-plus-square"></i>Neue Aktion hinzufügen
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="attachments" v-if="false">
            <img
              class="attachment"
              v-bind:src="getImgUrl(e.attached.pic)"
              alt
            />
          </div>
        </div>
      </kanban-board>
    </div>
  </div>
</template>

<script>
import { updateDatabaseItemKey } from '../services/userTable';
import { runFlowByID } from '../services/axios/flow-runner.api';
import Store from '../store/store';
import { getFlowLastId, debouncer } from '../utils/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'kanban',
  data() {
    return {
      selectedTask: {
        id: 0,
        new: false,
        status: 'ToDo',
        title: 'Neue Aufgabe',
        assignee: false,
        due: false,
        attached: false,
        description: '',
      },

      elOnHoverIdx: null,
      isActionDropdownVisible: false,
      showModal: false,
      lastID: null,
      isActionDropDownLoading: {
        itemID: null,
        actionID: null,
      },
    };
  },
  props: {
    stages: Array,
    blocks: Array,
    title: String,
    dataSchema: Array,
    keyTranslations: Object,
    isLoading: Boolean,
    database: Object,
    isCorrectElementType: {
      type: Function,
      required: true,
      default: () => {},
    },
    getElementSettings: { type: Function, default: () => {} },
    getSqlKey: { type: Function, default: () => {} },
    showToaster: {
      type: Function,
      required: true,
      default: () => {},
    },
    isSelectedItem: {
      type: Function,
      required: true,
    },
    statusFieldKey: {
      type: String,
      default: 'status',
    },
  },
  methods: {
    getStageKey(stage) {
      if (stage && typeof stage === 'object') {
        return stage.name ?? stage.value ?? stage.label;
      }
      return stage;
    },
    getStageLabel(stage) {
      if (stage && typeof stage === 'object') {
        return stage.label ?? stage.name ?? stage.value;
      }
      return stage;
    },
    getStatusValue(task) {
      return task?.[this.statusFieldKey] ?? task?.status;
    },
    setStatusValue(task, value) {
      this.$set(task, this.statusFieldKey, value);
    },
    normalizeStatusValue(value) {
      return value ? value : 'nostatus';
    },
    getDbStatusValue(value) {
      return value === 'nostatus' ? '' : value;
    },
    formatDate(value) {
      if (typeof value === 'string')
        return new Date(Number(value))?.toLocaleString();
      else return new Date(value)?.toLocaleString();
    },
    hideActionDropdown() {
      this.elOnHoverIdx = null;
      this.isActionDropdownVisible = false;
    },
    toggleActionDropdown() {
      this.isActionDropdownVisible = !this.isActionDropdownVisible;
    },
    check: function (event, f) {
      f.selected = !f.selected;
      this.$emit('checkSelectedItemOnClick', event, f);
      this.$forceUpdate();
    },
    actionList() {
      return Store.state.flows
        .filter((e) => e.type == 'action' && e.table_id == this.database.name)
        .sort((a, b) =>
          (a?.name || '').localeCompare(b?.name || '', undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
    },
    newID() {
      return getFlowLastId(this);
    },
    runAction: async function (id) {
      try {
        if (
          this.isActionDropDownLoading.actionID &&
          this.isActionDropDownLoading.itemID
        )
          return;
        this.isActionDropDownLoading = {
          actionID: id,
          itemID: this.elOnHoverIdx,
        };
        const params = `?id=${id}&modeldatabaseid=${this.database.name}&model=${this.elOnHoverIdx}`;
        const response = await runFlowByID('', params);

        if (response && response.status === 200 && response.data) {
          this.$emit('setHTMLViewer', {
            myHtml: response.data,
            isHtmlViewerVisible: true,
          });
        }
        this.isActionDropDownLoading = { actionID: null, itemID: null };
      } catch (error) {
        this.isActionDropDownLoading = { actionID: null, itemID: null };
      }
    },
    createNewAction: async function () {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'custom',
        fileKey: this.elOnHoverIdx
          ? this.elOnHoverIdx
          : this.selectedElements[0].id,
        tableID: this.database.name,
      });

      if (rslt == 'Access Token has expired') {
        this.handleTokenExpired();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },
    handleTokenExpired: function () {
      localStorage.clear(),
        this.$router.push({
          name: 'auth',
          params: { message: 'Sitzung abgelaufen' },
        });
    },
    fetchData() {
      if (this.$route.params.board) {
        this.board = this.$route.params.board;
      }
    },

    addBlock(stage) {
      const stageKey = this.getStageKey(stage);
      this.blocks.push({
        id: this.blocks.length,
        new: true,
        [this.statusFieldKey]: stageKey,
        title: 'Neue Aufgabe',
        due: false,
        assignee: false,
        attached: false,
      });
    },
    getColor: function () {
      //return colors[Math.floor(Math.random() * colors.length)];
      return 'rgb(202 199 199)';
    },
    getStageCount: function (s) {
      return this.extendedBlocks.filter((e) => this.getStatusValue(e) == s)
        .length;
    },
    getImgUrl: function (img) {
      var images = require.context('../assets/img/', false, /\.png$/);
      return images(img);
    },
    openTask: function (task) {
      this.selectedTask = task;
      this.showModal = true;
    },
    hideModel: function () {
      this.showModal = false;
    },
    getBlockName: function (block) {
      return Object.keys(block)[0];
    },
    displayParam(item) {
      // eslint-disable-next-line no-unused-vars
      let { id, selected, ...displayItem } = item;
      let highlightItems = this.getHighlightedItems(displayItem);

      // Return all if nothing is highlighted
      if (Object.keys(highlightItems).length < 1) {
        let keysToRemove = [
          'id',
          'owner',
          'created',
          'updated',
          'selected',
          'loading',
        ];

        // Get layoutitems
        let layoutItems = this.dataSchema
          .filter((e) => this.getElementSettings(e, 'layoutItem'))
          .map((e) => e.name);

        let copyItem = JSON.parse(JSON.stringify(displayItem));

        // Remove frontend & layout keys
        for (let k of keysToRemove.concat(layoutItems)) {
          delete copyItem[k];
        }

        return copyItem;
      }
      return this.sliceObject(this.getHighlightedItems(displayItem));
    },

    sliceObject: function (obj) {
      return Object.keys(obj)
        .slice(0, 6)
        .reduce((result, key) => {
          result[key] = obj[key];
          return result;
        }, {});
    },

    getHighlightedItems: function (items) {
      let highlightItems = {};

      Object.keys(items).forEach((el) => {
        let i = this.dataSchema.find((e) => e.name == el);
        if (i != undefined && i.highlight == true) {
          highlightItems[el] = items[el];
        }
      });

      return this.sortItemsAsSchemaOrder(highlightItems);
    },
    sortItemsAsSchemaOrder: function (items) {
      // Order items
      let itemOrder = this.dataSchema.map((e) => e.name);
      return JSON.parse(JSON.stringify(items, itemOrder));
    },
    formatValues(val) {
      const pattern = /^[0-9]{4}-[0-9]{2}-[0-9]{2}/gm;
      if (val === 'nostatus') return 'Kein Status';
      if (pattern.test(val))
        return new Date(val).toLocaleString().split(',')[0];
      return val;
    },
    async updateBlock(id, newStatus) {
      try {
        const container = this.$refs.kanban.$el;
        const statusKey = this.getStatusElementName;
        const nextStatusValue = this.normalizeStatusValue(newStatus);
        if (container) {
          const dataBlocksContainer = Array.from(
            container.querySelectorAll('.drag-inner-list')
          ).find((element) => element.dataset.status == nextStatusValue);

          if (dataBlocksContainer) {
            const dataBlockIds = [];

            for (const child of dataBlocksContainer.children) {
              if (child.hasAttribute('data-block-id')) {
                dataBlockIds.push(child.getAttribute('data-block-id'));
              }
            }

            const updatedFilteredItems = [];

            dataBlockIds.map((el, indx) => {
              const elementIndex = this.blocks.findIndex((ele) => ele.id == el);
              if (elementIndex > -1) {
                if (id == this.blocks[elementIndex].id) {
                  this.setStatusValue(
                    this.blocks[elementIndex],
                    this.getDbStatusValue(newStatus)
                  );
                }

                const blockStatus = isMovedBlock
                  ? nextStatusValue
                  : this.normalizeStatusValue(currentBlock[statusKey]);
                updatedFilteredItems.push({
                  ...this.blocks[elementIndex],
                  [statusKey]: blockStatus,
                  codelosKanbanOrder: indx,
                });
                this.$set(
                  this.blocks[elementIndex],
                  'codelosKanbanOrder',
                  indx
                );
              }
            });

            const statusUpdateItem = updatedFilteredItems.find(
              (el) => el.id == id
            );

            if (statusUpdateItem) {
              const payload = {
                value: this.getStatusValue(statusUpdateItem),
              };

              updateDatabaseItemKey(
                this.database.name,
                statusUpdateItem.id,
                this.statusFieldKey,
                payload
              );
            }

            await Promise.allSettled(
              updatedFilteredItems.map((item) => {
                const payload = { value: item.codelosKanbanOrder };
                return updateDatabaseItemKey(
                  this.database.name,
                  item.id,
                  'codelosKanbanOrder',
                  payload
                );
              })
            );
          }
        }
      } catch (error) {
        this.showToaster(error, 'Fehlerhaft !', 'danger');
      }
    },
    goTo: function (id) {
      this.$emit('goTo', id);
    },
    removeItem: function (e) {
      this.$emit('removeItem', e);
    },
    exportItem: function (e) {
      this.$emit('exportItem', e);
    },
    shareItem: function (e) {
      this.$emit('shareItem', e);
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    isDatabaseDropDownLoading(actionid, itemid) {
      return (
        this.isActionDropDownLoading.itemID !== null &&
        this.isActionDropDownLoading.actionID !== null &&
        this.isActionDropDownLoading.itemID == itemid &&
        this.isActionDropDownLoading.actionID == actionid
      );
    },
    isCheckboxChecked(item) {
      return this.isSelectedItem(item[this.getSqlKey('id')]);
    },
    normalizeStatusValue(value) {
      if (value === undefined || value === null || value === '') {
        return 'Kein Status';
      }

      const matchedOption = this.statusOptions.find(
        (option) => option.value == value || option.label == value
      );

      return matchedOption ? matchedOption.value : value;
    },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters({
      userHasPermissionToAddFlow: 'getUserPermissionToAddFlow',
    }),
    user() {
      return Store.state.user;
    },
    tableName() {
      return this.database.name;
    },
    stageItems() {
      const stages = Array.isArray(this.stages) ? this.stages : [];
      const mappedStages = stages.map((stage) => ({
        name: this.getStageKey(stage),
        label: this.getStageLabel(stage),
      }));
      if (!mappedStages.some((stage) => stage.name === 'nostatus')) {
        mappedStages.unshift({ name: 'nostatus', label: 'Kein Status' });
      }
      return mappedStages;
    },
    stageValues() {
      return this.stageItems.map((stage) => stage.name);
    },
    groupedBlocks() {
      let blocks = JSON.parse(JSON.stringify(this.blocks));

      const statusElement = this.getStatusElement;
      const statusKey = statusElement?.name || 'status';
      const groupedBlocks = blocks.reduce((acc, e) => {
        const statusValue = this.normalizeStatusValue(this.getStatusValue(e));

        if (!acc[statusValue]) {
          acc[statusValue] = [];
        }

        acc[statusValue].push(e);
        return acc;
      }, {});

      const finalGroupedBlocks = this.stageItems.reduce((acc, e) => {
        if (groupedBlocks.hasOwnProperty(e.name)) {
          acc[e.name] = groupedBlocks[e.name];
        } else {
          acc[e.name] = [];
        }
        return acc;
      }, {});

      return finalGroupedBlocks;
    },
    extendedBlocks() {
      const finalGroupedBlocks = this.groupedBlocks;

      const finalBlocksArr = [];

      Object.keys(finalGroupedBlocks).map((key) => {
        finalGroupedBlocks[key].map((ele) => {
          if (!ele.hasOwnProperty('codelosKanbanOrder'))
            ele.codelosKanbanOrder = finalGroupedBlocks[key].length;
          ele.selected = this.isCheckboxChecked(ele);
        });

        finalGroupedBlocks[key].sort(
          (a, b) => a.codelosKanbanOrder - b.codelosKanbanOrder
        );

        finalBlocksArr.push(finalGroupedBlocks[key]);
      });
      return finalBlocksArr.flat();
    },
  },
  events: {
    showAlert: function () {
      this.message();
    },
  },
  mounted() {
    const dragColumn =
      this.$refs?.kanban?.$el?.querySelectorAll('.drag-column')[0];
    if (dragColumn) {
      dragColumn.addEventListener('scroll', this.showScrollbar);
    }
  },
  destroyed() {
    const dragColumn =
      this.$refs?.kanban?.$el?.querySelectorAll('.drag-column')[0];
    if (dragColumn) {
      dragColumn.removeEventListener('scroll', this.showScrollbar);
    }
  },
  components: {},
};
</script>

<style>
.Modal {
  z-index: 10;
}
.kanban-board {
  background: #fff;
  font-family: open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
}

.stage-color {
  position: absolute;
  top: 0;
  width: 100%;
  height: 1px;
  left: 0px;
}

.background-warning {
  background: #f4c712;
}

.background-success {
  background: #00a553;
}

.background-danger {
  background: #f88639;
}

.background-info {
  background: #2e8ec1;
}

ul.drag-list,
ul.drag-inner-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.drag-container {
  margin: 0;
  /* overflow: auto;
    max-height: calc(100vh - 410px); */
}

.drag-list {
  display: flex;
  align-items: flex-start;
}

@media (max-width: 690px) {
  .drag-list {
    display: block;
  }
}
.drag-column {
  margin-bottom: 25px;
  margin-right: 14px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
  padding: 0 13px 2px 13px;
  border: 1px solid #e5eaf4;
  border-top: 0;
  background: #fff;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  -webkit-box-sizing: border-box;
  position: relative;
  display: block;
  float: left;
  min-width: 300px;
  box-sizing: border-box;
}

@media (max-width: 690px) {
  .drag-column {
    margin-bottom: 30px;
  }
}
.drag-column h2 {
  margin-top: 10px;
  font-size: 21px;
  font-weight: 500;
  color: black;
  cursor: default;
}
.drag-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.kanban-board .stage-count {
  margin-top: 13px;
  font-size: 15px;
  position: absolute;
  right: 16px;
  font-weight: 550;
}

.drag-inner-list {
  font-size: 14px;
  vertical-align: middle;
  text-align: left;
  border-color: darkgrey;
  min-height: 150px;
}

.drag-item {
  margin: 9px 0px;
  box-sizing: border-box;
  transition: all 0.25s ease;
  border: 1px solid #e5eaf4;
  border-radius: 4px;
  background: #fff;
  cursor: grab;
  -webkit-box-shadow: 0 1px 0px 0 rgb(0 0 0 / 6%), 0 1px 5px 0 rgb(0 0 0 / 8%);
}

.kanban-board .dz-preview-wrapper.board-layout {
  position: relative;
  min-height: 85px;
  padding: 15px 16px;
}

.drag-item.is-moving {
  transform: scale(1.1);
  font-family: open-sans, sans-serif;
  font-weight: 400;
  color: #5f697a;
}

.drag-header-more {
  cursor: pointer;
}

.drag-options {
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  transform: translateX(100%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

.drag-options.active {
  transform: translateX(0);
  opacity: 1;
}

.drag-options-label {
  display: block;
  margin: 0 0 5px 0;
}

.drag-options-label input {
  opacity: 0.6;
}

input {
  height: 30px;
  width: 223px;
  display: block;
  text-overflow: ellipsis;
  border: none;
  font-weight: 500;
  color: #5f697a;
  font-size: 13px;
  cursor: grab;
}

.drag-options-label span {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 400;
  margin-left: 5px;
}

/* Dragula CSS  */
.gu-mirror {
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
  opacity: 0.8;
  list-style-type: none;
}

.gu-hide {
  display: none !important;
}

.gu-unselectable {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.gu-transit {
  opacity: 0.2;
}

.kanban-board .user {
  width: 40px;
  margin-right: 10px;
  float: left;
}

.kanban-board .date {
  margin-left: 3px;
  background-color: #f53c3b;
  border: 1px solid #dd2f2e;
  color: #fff;
  font-size: 11px;
  position: relative;
  display: inline-block;
  margin-top: 5px;
  margin-right: 10px;
  border-radius: 2px;
  font-family: open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  padding-left: 3px;
  padding-right: 5px;
}

.attachment {
  width: 200px;
  margin: 0 20px 20px 0;
  cursor: pointer;
}

.attachments {
  width: 100%;
  display: block;
  min-height: 10px;
  margin-top: 20px;
}

.add-button {
  font-size: 37px;
  text-align: center;
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-weight: 100;
  cursor: pointer;
  margin-bottom: 10px;
}

.details {
  min-height: 47px;
}

.details img {
  border-radius: 30px;
}

.highlighted-item {
  margin-bottom: 5px;
  font-size: 13px;
  color: #393838;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-weight: 300;
  letter-spacing: 0.125px;
  text-transform: none;
  text-align: left;
  overflow: hidden;
  height: -moz-fit-content;
  height: fit-content;
}

.dz-preview {
  display: inline-block;
  position: relative;
  width: 388px;
  height: 388px;
  margin: 0 30px 30px 0;
  border-radius: 4px;
  -webkit-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  background: white;
}

.dz-preview.list {
  width: 100%;
  height: 60px;
  overflow: hidden;
  box-shadow: rgb(0 0 0 / 6%) 0px 3px 12px 0px, rgb(0 0 0 / 16%) 0px 1px 3px 0px;
  outline: none;
}

.dz-preview.list:hover {
  outline: none;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 4px 0px,
    rgb(0 0 0 / 14%) 0px 10px 16px 0px;
}

.dz-preview.checked.list:hover {
  box-shadow: 0 0 0 2px #1fc281;
}

.dz-message {
  color: #808ca7;
  margin-top: 35px;
}

.dz-message h2 {
  font-size: 43px;
  font-weight: 600;
  color: #808ba7;
  margin-top: 13px;
}

.dz-message p {
  font-size: 18px;
  font-weight: 100;
}

.dz-started .dz-message {
  display: none;
}

.dz-preview:hover {
  transform: translateY(-4px);
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.3), 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.dz-preview.loading:hover {
  transform: none;
  box-shadow: none;
}

.dz-preview.checked {
  transform: translateY(-4px);
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.data-dz-thumbnail-bg-overlay {
  opacity: 1;
}

.dz-preview .dz-image {
  height: 224px;
  top: 0;
}

.dz-preview.dz-file-preview.list .dz-preview-wrapper .dz-image {
  height: 60px;
  width: 100%;
  position: absolute;
  z-index: 70;
  top: 0;
}

.data-dz-thumbnail-bg {
  z-index: 1;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 224px;
  width: 100%;
  position: absolute;
}

.data-dz-thumbnail-bg {
  height: 60px;
}

.data-dz-thumbnail-bg.loading {
  z-index: 4000;
  height: 290px;
  border-radius: 4px;
  opacity: 1;
}

.data-dz-thumbnail-bg-overlay.loading {
  opacity: 1;
}

.dz-preview-wrapper.board-layout:hover .data-dz-thumbnail-bg-overlay,
.data-dz-thumbnail-bg-overlay.selected {
  opacity: 1;
}

.overlay-checkbox .data-dz-thumbnail-bg-overlay.checked div.checker span {
  background-position: -398px -283px;
}

.data-dz-thumbnail-bg-overlay.checked {
  opacity: 1;
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  transition: none;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  overflow: hidden;
  border-radius: 4px;
  left: 0;
  height: 101%;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.7);
  transition: opacity 450ms ease-in-out;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  height: 360px;
  border-radius: 4px;
  opacity: 1;
}

.data-dz-thumbnail-bg.processing {
  background-color: mediumslateblue;
}
.data-dz-thumbnail-bg.success {
  background-color: lightgreen;
}

.dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  background-size: contain;
}

.dz-preview .dz-image > img {
  width: 100%;
}

.dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.dz-preview .dz-progress {
  opacity: 1;
  height: 16px;
  width: 80px;
  background: hsla(0, 0%, 100%, 0.9);
  transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dz-preview .dz-details {
  margin: 1px 18px 0;
  text-align: left;
}

.dz-preview .dz-details select {
  border: none;
  outline: none;
  background: white;
  color: #5f697a;
}

.tools > li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 8px;
}

.tools a {
  text-indent: -9999px;
}

a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  left: 0;
  width: 125px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 2px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
  bottom: 0;
  top: 0;
  right: 0;
  margin: auto;
  text-align: center;
  opacity: 1 !important;
  visibility: visible !important;
}

.list a.btn-oval {
  top: 12px;
  left: 72%;
  right: 127px;
  opacity: 0;
}

.list:hover a.btn-oval {
  color: #4c5572;
  opacity: 1;
  background-color: #ffff;
  position: unset;
  padding: 12px 37px;
  border: 1px solid #ccc;
  border-radius: 4px 4px 4px 4px;
}

.dz-preview.list a.btn-oval:hover {
  top: 12px;
  left: 72%;
}

a.btn-oval:hover {
  border-color: white;
}

.tools {
  position: absolute;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

.tools a {
  text-indent: -9999px;
}

.tools > li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.download a {
  background-position: -868px -646px;
}

.tools li.delete a {
  background-position: -129px -759px;
}

.tools li.dropdown a {
  background-position: -323px -754px;
  width: 22px;
}

.first {
  font-size: 16px;
  font-weight: 400;
  color: black;
}

.board-layout .dz-details .highlighted-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 230px;
}

.overlay-checkbox .data-dz-thumbnail-bg-overlay div.checker {
  height: 20px;
  width: 20px;
  margin: 14px 0 0 16px;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 1;
  z-index: 1;
  display: block;
  line-height: 21px;
  position: relative;
  zoom: 1;
  position: relative;
}

.overlay-checkbox .data-dz-thumbnail-bg-overlay div.checker span {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.overlay-checkbox
  .data-dz-thumbnail-bg-overlay
  div.checker[data-v-5d4b3a5f]:hover {
  opacity: 1;
}

.overlay-checkbox
  .data-dz-thumbnail-bg-overlay
  div.checker
  span.checked[data-v-5d4b3a5f] {
  background-position: -398px -283px;
}

/*new Header*/
.kanban-board-header {
  display: flex;
}

.kanban-board-header > div {
  position: relative;
  margin-right: 14px;
  padding: 9px 13px 5px 13px;
  box-sizing: border-box;
  min-width: 300px;
}

.kanban-board-header-wrap {
  position: sticky;
  top: 0;
  z-index: 6;
}

.kanban-board-header-wrap h2 {
  font-size: 20px;
  color: black;
}

.kanban-board-header .stage-count {
  position: relative;
  margin: 0;
  right: 0;
  font-size: 16px;
  right: 0;
  top: 3px;
}

.kanban-board-header-wrap .kanban-board-header > div {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: flex-start;
  border: 1px solid #e5eaf4;
  border-bottom: 0;
  background: #fff;
}

.drag-column .drag-column-header {
  display: none;
}

.kanban-board-wrapper > div {
  height: calc(99vh - 210px) !important;
  overflow: auto;
}

.kanban-board-wrapper .height-change {
  height: calc(92vh - 155px) !important;
}

.kanban-board-wrapper {
  overflow: unset;
  height: auto !important;
  padding: 0;
  box-sizing: border-box;
}
.data-dz-thumbnail-bg-overlay.loading {
  background-color: rgba(25, 29, 38, 0.7);
}

/* Action dropdown basic style */
.dropdown.action-dropdown {
  display: contents;
  height: 100%;
}

.dropdown.action-dropdown ul {
  width: 215px;
  display: grid;
  max-height: 120px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  position: absolute;
  right: 0;
  background: #fff;
  top: 30px;
  min-width: 90px;
  padding: 0;
  border-radius: 4px;
  text-align: left;
  margin-right: 5px;
  z-index: 9;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  min-height: 30px;
}

.dropdown.action-dropdown li {
  line-height: 1.5;
  font-size: 16px;
  cursor: pointer;
  padding: 5px 10px;
  position: relative;
}
.dropdown.action-dropdown li:hover {
  background: #f0f0f0;
}

.dropdown.action-dropdown ul::-webkit-scrollbar-thumb {
  background: #b8b8b8;
  border-radius: 0px;
}
.dropdown.action-dropdown ul::-webkit-scrollbar-thumb:hover {
  background: #959595;
}

.kanban-board .create-new-action {
  padding-left: 11px;
  font-size: 12px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  padding-bottom: 4px;
  line-height: 20px;
}

.listitem-hover {
  line-height: 1.5;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 10px;
}

.create-new-action i {
  margin-right: 10px;
}

.data-dz-thumbnail-bg-overlay.loading {
  background-color: rgba(25, 29, 38, 0.7);
}

.data-dz-thumbnail-bg-overlay.loading .progress-icon {
  left: unset;
  top: 50%;
  margin: 0 auto;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
}

.data-dz-thumbnail-bg-overlay.loading .progress-icon:after {
  width: 35px;
  height: 35px;
  box-sizing: border-box;
}

.loading .tools,
.loading .checker,
.loading .btn-oval {
  display: none !important;
}
.loading .progress-icon {
  z-index: 6;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
}

.loadingWrapper .data-dz-thumbnail-bg-overlay {
  opacity: 1;
}

.loadingWrapper .data-dz-thumbnail-bg-overlay .tools,
.loadingWrapper .data-dz-thumbnail-bg-overlay .btn-oval,
.loadingWrapper .data-dz-thumbnail-bg-overlay .checker {
  display: none !important;
}

.loadingWrapper .progress-icon {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 6;
  transform: translateY(-50%);
}
.kanban-board-wrapper > div.with-new-btn {
  height: calc(100vh - 310px) !important;
}
.kanban-board .drag-column::-webkit-scrollbar {
  width: 4px;
}

.kanban-board .drag-column::-webkit-scrollbar-track {
  border-radius: 7px;
  background-color: transparent;
  border: 1px solid transparent;
}
.kanban-board .drag-column::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #565656;
}
@media screen and (max-width: 1366px) {
  .kanban-board .drag-column::-webkit-scrollbar-thumb {
    display: none;
  }
}
.kanban-board .drag-column.show-scrollbar::-webkit-scrollbar-thumb {
  display: block;
}

.kanban-board .action-dropdown .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}
.kanban-board .action-dropdown .loadingoverlay .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  /* top: 5px; */
  position: absolute;
  left: 45%;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
